// extracted by mini-css-extract-plugin
export default {"flipCardInner":"Card_flipCardInner__CAgjF","flipCard":"Card_flipCard__e74Nn","flipCardFront":"Card_flipCardFront__W8DG+","flipCardBack":"Card_flipCardBack__rgD6r"};